import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { apiGet } from 'utils/apiFetch'
import apiPath from 'utils/apiPath'
import Pagination from 'pages/Pagination'
import UserListTable from './userListTable'
// import ODateRangePicker from 'components/shared/datePicker/ODateRangePicker'

function UserListModal({ setIsUserModalOpen, selected, setSelected, setIsUserNameValid }) {
  const { t } = useTranslation()
  const [user, setUser] = useState([])
  const [page, setPage] = useState(1)
  const [pageSize] = useState(10)
  const [isDelete, setIsDelete] = useState(false)
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10
  })
  const [filterData, setFilterData] = useState({
    category: '',
    searchkey: '',
    startDate: '',
    endDate: '',
    isReset: false,
    isFilter: false
  })
  const [sort, setSort] = useState({
    sortKey: 'createdAt',
    sortType: 'desc'
  })
  const { category, startDate, endDate, searchkey, isFilter } = filterData
  const allUser = async data => {
    try {
      if (
        (data?.deletePage && !(user?.length > 1)) ||
        (isFilter && category && data?.statusChange && !(user?.length > 1))
      ) {
        setPage(page - 1)
        setIsDelete(true)
        setPaginationObj({ ...paginationObj, page: page - 1 })
      } else {
        setIsDelete(false)
      }

      const payload = {
        page,
        pageSize: pageSize,
        keyword: searchkey.trim(),
        sortKey: sort.sortKey,
        sortType: sort.sortType
      }

      const path = apiPath.getUsers
      const result = await apiGet(path, payload)
      // if (result?.data?.success) {
      const response = result?.data?.results
      const resultStatus = result?.data?.success
      setUser(response?.docs)
      setPaginationObj({
        ...paginationObj,
        page: resultStatus ? response.page : null,
        pageCount: resultStatus ? response.totalPages : null,
        perPageItem: resultStatus ? response?.docs.length : null,
        totalItems: resultStatus ? response.totalDocs : null
      })
      // }
    } catch (error) {
      console.log('error in get all users list==>>>>', error.message)
    }
  }
  const handlePageClick = event => {
    const newPage = event.selected + 1
    setPage(newPage)
  }

  useEffect(() => {
    allUser()
  }, [startDate, endDate, isFilter, searchkey, category, page, sort])

  const handleChangeData = e => {
    setFilterData({ ...filterData, searchkey: e.target.value, isFilter: true })
    setPage(1)
  }

  return (
    <>
      <div className='justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none'>
        <div className='relative w-auto my-6 mx-auto max-w-[1200px]'>
          <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
            <div className='border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none min-w-[762px]'>
              <div className='flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t'>
                <h3 className='text-xl font-semibold'>{t('O_USERS')}</h3>
                <button
                  className=' ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none'
                  onClick={() => setIsUserModalOpen(false)}
                >
                  <span
                    className=' text-[#B8BBBF]  text-4xl '
                    title={t('O_CLOSE')}
                  >
                    ×
                  </span>
                </button>
              </div>
              <div className='relative p-3 flex-auto'>
                <div>
                  <div className='bg-[#F9F9F9]'>
                    <div className='px-3 py-4'>
                      <div className='bg-white border border-[#E9EDF9] rounded-lg'>
                        <form className='border-b border-b-[#E3E3E3] 2xl:flex gap-2 px-4 py-3'>
                          <div className='2xl:ml-auto xl:ml-0 lg:pt-0 pt-2'>
                            <label
                              htmlFor='default-search'
                              className='mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white'
                            >
                              {t('O_SEARCH_BY_NAME')}
                            </label>
                            <div className='flex'>
                              <div className='relative '>
                                <div className='absolute inset-y-0 right-0 flex items-center pl-3 mr-3 pointer-events-none'>
                                  <svg
                                    aria-hidden='true'
                                    className='w-4 h-4 text-[#A5A5A5] dark:text-gray-40'
                                    fill='none'
                                    stroke='currentColor'
                                    viewBox='0 0 24 24'
                                    xmlns='http://www.w3.org/2000/svg'
                                  >
                                    {!filterData?.searchkey && (
                                      <path
                                        strokeLinecap='round'
                                        strokeLinejoin='round'
                                        strokeWidth='2'
                                        d='M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z'
                                      />
                                    )}
                                  </svg>
                                </div>
                                <input
                                  type='search'
                                  id='default-search'
                                  title=''
                                  className='block w-full p-2 outline-none text-sm text-gray-900 2xl:min-w-[300px] xl:min-w-[300px] rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                                  placeholder={t(
                                    'O_SEARCH_BY_NAME'
                                  )}
                                  value={filterData?.searchkey}
                                  required
                                  onChange={e => handleChangeData(e)}
                                />
                              </div>
                            </div>
                          </div>
                        </form>
                        <UserListTable
                          user={user}
                          page={page}
                          setSort={setSort}
                          sort={sort}
                          setSelected={setSelected}
                          selected={selected}
                          setIsUserModalOpen={setIsUserModalOpen}
                          setIsUserNameValid={setIsUserNameValid}
                        />
                        {paginationObj?.totalItems
                          ? (
                            <Pagination
                              handlePageClick={handlePageClick}
                              options={paginationObj}
                              isDelete={isDelete}
                              page={page}
                            />
                          )
                          : null}
                      </div>
                    </div>
                  </div>
                </div>
                <div className='flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b'>
                  <button
                    className='text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150'
                    type='button'
                    onClick={() => setIsUserModalOpen(false)}
                  >
                    {t('O_CLOSE')}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='opacity-25 fixed inset-0 z-40 bg-black' />
    </>
  )
}

export default UserListModal
